export default __webpack_public_path__ + "static/media/guest_13_02_akin_abaz.60a077e6.png";